module.exports = __webpack_public_path__ + "static/media/notificationSound.afded356.mp3";